"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankLogo = void 0;
var BankLogo;
(function (BankLogo) {
    BankLogo["BancoDoBrasil"] = "https://warren.com.br/assets/pension/banks/bancodobrasil.svg";
    BankLogo["Barinsul"] = "https://warren.com.br/assets/pension/banks/banrisul.svg";
    BankLogo["Bradesco"] = "https://warren.com.br/assets/pension/banks/bradesco.svg";
    BankLogo["Inter"] = "https://warren.com.br/assets/pension/banks/inter.svg";
    BankLogo["Itau"] = "https://warren.com.br/assets/pension/banks/itau.svg";
    BankLogo["Original"] = "https://warren.com.br/assets/pension/banks/original.svg";
    BankLogo["Santander"] = "https://warren.com.br/assets/pension/banks/santander.svg";
    BankLogo["Other"] = "https://warren.com.br/assets/pension/banks/other.svg";
})(BankLogo = exports.BankLogo || (exports.BankLogo = {}));
//# sourceMappingURL=BankLogo.js.map